import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { WORKSPACE_INVITE_PATH_PREFIX, consumePendingWorkspaceInvite } from '../../../common/workspace-invitation'

const WorkspaceInvitationResume = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (location.pathname.startsWith(WORKSPACE_INVITE_PATH_PREFIX)) {
      consumePendingWorkspaceInvite()
      return
    }
    const pendingToken = consumePendingWorkspaceInvite()
    if (!pendingToken) return
    navigate(`${WORKSPACE_INVITE_PATH_PREFIX}${pendingToken}`, { replace: true })
  }, [location.pathname, navigate])

  return null
}

export default WorkspaceInvitationResume
